import React, { useContext, useEffect, useState } from 'react'
import Form from "../components/form/form";
import Dropdown from "../components/form/dropdown";
import {
    dataForEthnicity,
    dataForGender,
    dataForMartialStatus,
    dataForNotificationPreference,
    dataForPreferenceLanguage,
    dataForRace,
    dataForState,
} from "./datasource";
import moment from "moment";
import {validateEmail} from "../utils/utils";
import CameraPicker from "../components/cameraPicker/cameraPicker";
import {ActionContext, ActionType} from "../components/hooks/provider";
import {ElementID, Page, PatientInfo} from "./types";
import { checkin, updatePatientInfo } from './service'
import {LangManager} from "../components/i18n/langManager";
import {mPrint} from "../utils/mPrint";
import {Element, scroller} from "react-scroll"
import BridgeHelper, { openInApp } from '../bridge/bridgeHelper'
import { PromptContext } from '../utils/promptContext'
import { useParams } from 'react-router-dom'

interface IProps {
    patientInfo: PatientInfo,
    onSavePatientInfo: (info: PatientInfo) => void
}

export default function Profile(props: IProps) {
    const [patientInfo, setPatientInfo] = useState<PatientInfo>(props.patientInfo)
    const [submitted, setSubmitted] = useState(false)
    const [skipInsurance, setSkipInsurance] = useState<boolean>(false)
    const [openCameraPicker, setOpenCameraPicker] = useState<boolean>(false)
    const [frontInsuranceCard, setFrontInsuranceCard] = useState<boolean>(false)
    const {dispatchActionState, actionState} = useContext(ActionContext)

    const {showSpinner, hideSpinner} = useContext(PromptContext)

    const {token} = useParams()

    useEffect(() => {
        setPatientInfo(patientInfo)
    }, [props.patientInfo])

    const langManager = LangManager(actionState.language)
    const $title = (
        <p className={"text-black text-base font-medium leading-5"}>{`${langManager.onlineCheckin} ${patientInfo.name}`}</p>
    )

    const $description = (
        <div className={"w-full h-max bg-[#EEF3F9] flex flex-col space-y-2 mt-3"}>
            <div className={"w-full"}>
                <span className={"text-base text-[#365496]"}>{langManager.steps(1)} </span><span className={"text-base text-black"}>{langManager.profileInfo}</span>
            </div>
            <p className={"text-sm text-black"}>{langManager.takeMomentsDesc}</p>
        </div>
    )

    const errMsgForPhoneNumber = submitted && !patientInfo.patientMobilePhone.length ? langManager.errMsgRequired(langManager.mobilePhone) : ""
    const $phoneNumber = (
        <Element name={ElementID.phoneNumber} className={"element"}>
            <div className={"w-full flex flex-col space-y-1"}>
                <Form onChangeText={(text) => {
                    setPatientInfo({
                        ...patientInfo,
                        patientMobilePhone: text,
                    })
                }} errMsg={errMsgForPhoneNumber} title={langManager.mobilePhone} value={patientInfo.patientMobilePhone} />
                {/*{patientInfo.patientID > 0 ? null : <p className={"text-xs text-[#828282] italic"}>{langManager.contactClinicInfo}</p>}*/}
            </div>
        </Element>
    )

    const errMsgForFirstName = submitted && !patientInfo.patientFirstName.length ? langManager.pleaseFillField : ""
    const errMsgForLastName = submitted && !patientInfo.patientLastName.length ? langManager.pleaseFillField : ""
    const $name = (
        <Element name={ElementID.name} className={"element"}>
            <div className={"w-full flex flex-col space-y-1"}>
                <p className={"text-sm font-medium text-black leading-5"}>{langManager.name}</p>
                <div className={"w-full grid grid-cols-2 space-x-6"}>
                    <div>
                        <Form disabled={patientInfo.patientID > 0} errMsg={errMsgForFirstName} placeholder={langManager.firstName} title={""} value={patientInfo.patientFirstName} onChangeText={(text) => {
                            setPatientInfo({
                                ...patientInfo,
                                patientFirstName: text,
                            })
                        }}/>
                    </div>
                    <div>
                        <Form disabled={patientInfo.patientID > 0} errMsg={errMsgForLastName} placeholder={langManager.lastName} title={""} value={patientInfo.patientLastName} onChangeText={(text) => {
                            setPatientInfo({
                                ...patientInfo,
                                patientLastName: text,
                            })
                        }}/>
                    </div>
                </div>
            </div>
        </Element>
    )

    const errMsgForDob = submitted && !moment(patientInfo.patientDOB, "YYYY-MM-DD").isValid() ? langManager.pleaseFillField : ""
    const maxDate = moment().format("YYYY-MM-DD")
    const dobM = moment(patientInfo.patientDOB, "YYYY-MM-DD")
    const valueForDOB = !dobM.isValid() ? "" : patientInfo.patientDOB
    const $dob = (
        <Element name={ElementID.dob} className={"element"}>
            <Form disabled={patientInfo.patientID > 0} max={maxDate} errMsg={errMsgForDob} type={"date"} placeholder={"MM/DD/YYYY"} title={langManager.dateOfBirth} value={valueForDOB} onChangeText={(text) => {
                setPatientInfo({
                    ...patientInfo,
                    patientDOB: text,
                })
            }} />
        </Element>
    )

    const errMsgForMarry = submitted && !patientInfo.patientMarrage.name.length ? langManager.errMsgRequired(langManager.martialStatus) : ""
    const $martialStatus = (
        <Element name={ElementID.marriageStatus} className={"element"}>
            <Dropdown errMsg={errMsgForMarry} title={langManager.martialStatus} placeholder={langManager.select} dataSource={dataForMartialStatus} selected={patientInfo.patientMarrage} onChange={(item) => {
                setPatientInfo({
                    ...patientInfo,
                    patientMarrage: item,
                })
            }}/>
        </Element>
    )

    const errMsgForGender = submitted && !patientInfo.patientGender.name.length ? langManager.errMsgRequired(langManager.gender) : ""
    const $gender = (
        <Element name={ElementID.gender} className={"element"}>
            <Dropdown errMsg={errMsgForGender} title={langManager.gender} placeholder={langManager.select} dataSource={dataForGender} selected={patientInfo.patientGender} onChange={(item) => {
                setPatientInfo({
                    ...patientInfo,
                    patientGender: item,
                })
            }}/>
        </Element>
    )

    const errMsgForRace = submitted && !patientInfo.race.name.length ? langManager.errMsgRequired(langManager.race) : ""
    const $race = (
        <Element name={ElementID.race} className={"element"}>{
            // patientInfo.patientID ? (
            //     <Form title={langManager.race} value={patientInfo.race.name} />) : (
            //     <Dropdown errMsg={errMsgForRace} title={langManager.race} placeholder={langManager.select} dataSource={dataForRace} selected={patientInfo.race} onChange={(item) => {
            //         setPatientInfo({
            //             ...patientInfo,
            //             race: item,
            //         })
            //     }}/>)
            <Dropdown errMsg={errMsgForRace} title={langManager.race} placeholder={langManager.select} dataSource={dataForRace} selected={patientInfo.race} onChange={(item) => {
                setPatientInfo({
                    ...patientInfo,
                    race: item,
                })
            }}/>
        }</Element>
    )

    const errMsgForEthnicity = submitted && !patientInfo.ethnicity.name.length ? langManager.errMsgRequired(langManager.ethnicity) : ""
    const $ethnicity = (
        <Element name={ElementID.ethnicity} className={"element"}>
            {/*{patientInfo.patientID ? (<Form title={langManager.ethnicity} value={patientInfo.ethnicity.name} />) : (*/}
            {/*    <Dropdown errMsg={errMsgForEthnicity} title={langManager.ethnicity} placeholder={langManager.select} dataSource={dataForEthnicity} selected={patientInfo.ethnicity} onChange={(item) => {*/}
            {/*        setPatientInfo({*/}
            {/*            ...patientInfo,*/}
            {/*            ethnicity: item,*/}
            {/*        })*/}
            {/*    }}/>*/}
            {/*)}*/}
            <Dropdown errMsg={errMsgForEthnicity} title={langManager.ethnicity} placeholder={langManager.select} dataSource={dataForEthnicity} selected={patientInfo.ethnicity} onChange={(item) => {
                setPatientInfo({
                    ...patientInfo,
                    ethnicity: item,
                })
            }}/>
        </Element>
    )

    const errMsgForEmail = submitted && !validateEmail(patientInfo.patientEMail) ? langManager.emailInvalid : ""
    const $email = (
        <Element name={ElementID.email} className={"element"}>
            <Form errMsg={errMsgForEmail} type={"email"} title={langManager.email} value={patientInfo.patientEMail} onChangeText={(text) => {
                setPatientInfo({
                    ...patientInfo,
                    patientEMail: text,
                })
            }} />
        </Element>
    )

    const errMsgForPreferredLanguage = submitted && !patientInfo.language.name.length ? langManager.errMsgRequired(langManager.preferredLanguage) : ""
    const $language = (
        <Element name={ElementID.language} className={"element"}>
            <Dropdown errMsg={errMsgForPreferredLanguage} title={langManager.preferredLanguage} placeholder={langManager.select} dataSource={dataForPreferenceLanguage} selected={patientInfo.language} onChange={(item) => {
                setPatientInfo({
                    ...patientInfo,
                    language: item,
                })
            }}/>
        </Element>
    )

    const errMsgForNotificationPreferences = submitted && !patientInfo.contactMethod.name.length ? langManager.errMsgRequired(langManager.notificationPreferences) : ""
    const $Notification = (
        <Element name={ElementID.notification} className={"element"}>
            <Dropdown errMsg={errMsgForNotificationPreferences} title={langManager.notificationPreferences} placeholder={langManager.select} dataSource={dataForNotificationPreference} selected={patientInfo.contactMethod} onChange={(item) => {
                setPatientInfo({
                    ...patientInfo,
                    contactMethod: item,
                })
            }}/>
        </Element>
    )

    const errMsgForAddress1 = submitted && !patientInfo.patientAddrStreet.length ? langManager.errMsgRequired(langManager.address) : ""
    const $addressLine1 = (
        <Element name={ElementID.address} className={"element"}>
            <Form errMsg={errMsgForAddress1} placeholder={langManager.addressLine1} title={langManager.address} value={patientInfo.patientAddrStreet} onChangeText={(text) => {
                setPatientInfo({
                    ...patientInfo,
                    patientAddrStreet: text,
                })
            }}/>
        </Element>
    )

    const $addressLine2 = (
        <Form placeholder={langManager.addressLine2} title={""} value={patientInfo.patientAddrStreet2} onChangeText={(text) => {
            setPatientInfo({
                ...patientInfo,
                patientAddrStreet2: text,
            })
        }}/>
    )

    const errMsgForCity = submitted && !patientInfo.patientAddrCity.length ? langManager.errMsgRequired(langManager.city) : ""
    const $city = (
        <Form errMsg={errMsgForCity} placeholder={langManager.city} value={patientInfo.patientAddrCity} onChangeText={(text) => {
            setPatientInfo({
                ...patientInfo,
                patientAddrCity: text,
            })
        }}/>
    )

    const errMsgForState = submitted && !patientInfo.patientAddrState.name.length ? langManager.errMsgRequired(langManager.state) : ""
    const $state = (
        <Dropdown errMsg={errMsgForState} placeholder={langManager.state} title={""} dataSource={dataForState} selected={patientInfo.patientAddrState} onChange={(item) => {
            setPatientInfo({
                ...patientInfo,
                patientAddrState: item,
            })
        }}/>
    )

    const errMsgForZip = submitted && !patientInfo.patientAddrZip.length ? langManager.errMsgRequired(langManager.zipCode) : ""
    const $zip = (
        <Form errMsg={errMsgForZip} placeholder={langManager.zipCode} value={patientInfo.patientAddrZip} onChangeText={(text) => {
            setPatientInfo({
                ...patientInfo,
                patientAddrZip: text,
            })
        }} />
    )

    const onTakePhoto = (dataUri: string) => {
        setOpenCameraPicker(false)
        if (frontInsuranceCard) {
            setPatientInfo({
                ...patientInfo,
                insuranceCardBackBase64: dataUri,
            })
        } else {
            setPatientInfo({
                ...patientInfo,
                insuranceCardFrontBase64: dataUri,
            })
        }
    }
    const $cameraPicker = (
        <CameraPicker isOpen={openCameraPicker} onTakePhoto={onTakePhoto} />
    )

    const $insuranceCards = (
        <div className={`w-full flex flex-col space-y-4 transition ease-in-out delay-150 ${skipInsurance ? "hidden" : ""}`}>
            <div className={"relative w-full h-[240px] flex flex-col items-center justify-center bg-[#EEF3F9] rounded-xl relative"}>
                {patientInfo.insuranceCardBackBase64 ? <div className={"w-full h-full flex flex-row justify-end relative"}>
                    <div className={"absolute inset-0 object-contain z-0 p-2"}>
                        <img alt={"front image"} src={"data:image/jpeg;base64," + patientInfo.insuranceCardBackBase64} className={"w-full h-full object-contain"}/>
                    </div>
                    <button type={"button"} onClick={() => {
                        setPatientInfo({
                            ...patientInfo,
                            insuranceCardBackBase64: null,
                        })
                    }} className={"w-11 h-11 bg-black/30 flex items-center justify-center mt-2 mr-2 rounded-full z-10"}>
                        <svg width="24" height="24" viewBox="0 0 48 48" fill="#365496" xmlns="http://www.w3.org/2000/svg"><path d="M14 14L34 34" stroke="#365496" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 34L34 14" stroke="#365496" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </button>
                </div>
                    :
                    <>
                        <p className={"absolute left-0 top-2.5 w-full text-primary text-left text-sm leading-5 pl-10"}>{langManager.frontCardInsurance}</p>
                        <button type={"button"} onClick={() => {
                            setFrontInsuranceCard(true)
                            setOpenCameraPicker(true)
                        }}>
                            <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M65.0667 23.1115H52.2667L49.3333 17.2448C49.0667 16.7115 48.5333 16.4448 48.2667 16.4448H32.2667C31.7333 16.4448 31.2 16.7115 31.2 17.2448L28.2667 23.1115H14.9333C11.2 23.1115 8.26666 26.0448 8.26666 29.7782V57.7782C8.26666 61.5115 11.2 64.4448 14.9333 64.4448H65.0667C68.8 64.4448 71.7333 61.5115 71.7333 57.7782V29.7782C71.7333 26.0448 68.8 23.1115 65.0667 23.1115ZM40 57.2448C32.2667 57.2448 26.1333 51.1115 26.1333 43.3782C26.1333 35.6448 32.2667 29.5115 40 29.5115C47.7333 29.5115 53.8667 35.6448 53.8667 43.3782C53.8667 50.8448 47.7333 57.2448 40 57.2448ZM60.5333 34.8448C59.4667 34.8448 58.4 34.0448 58.4 32.7115C58.4 31.3782 59.2 30.5782 60.5333 30.5782C61.6 30.5782 62.6667 31.3782 62.6667 32.7115C62.6667 34.0448 61.6 34.8448 60.5333 34.8448Z" fill="#365496"/>
                            </svg>
                            <p className={"text-primary text-sm"}>{langManager.takePhoto}</p>
                        </button>
                    </>}
            </div>

            <div className={"relative w-full h-[240px] flex flex-col items-center justify-center bg-[#EEF3F9] rounded-xl relative"}>
                {patientInfo.insuranceCardFrontBase64 ? <div className={"w-full h-full flex flex-row justify-end relative"}>
                    <div className={"absolute inset-0 object-contain p-2"}>
                        <img alt={"back image"} src={"data:image/jpeg;base64," + patientInfo.insuranceCardFrontBase64} className={"w-full h-full object-contain"}/>
                    </div>
                    <button type={"button"} onClick={() => {
                        setPatientInfo({
                            ...patientInfo,
                            insuranceCardFrontBase64: null,
                        })
                    }} className={"w-11 h-11 bg-black/30 flex items-center justify-center mt-2 mr-2 rounded-full z-10"}>
                        <svg width="24" height="24" viewBox="0 0 48 48" fill="#365496" xmlns="http://www.w3.org/2000/svg"><path d="M14 14L34 34" stroke="#365496" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 34L34 14" stroke="#365496" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </button>
                </div>
                    :
                    <>
                        <p className={"absolute left-0 top-2.5 w-full text-primary text-left text-sm leading-5 pl-10"}>{langManager.backCardInsurance}</p>
                        <button type={"button"} onClick={() => {
                            setFrontInsuranceCard(false)
                            setOpenCameraPicker(true)
                        }}>
                            <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M65.0667 23.1115H52.2667L49.3333 17.2448C49.0667 16.7115 48.5333 16.4448 48.2667 16.4448H32.2667C31.7333 16.4448 31.2 16.7115 31.2 17.2448L28.2667 23.1115H14.9333C11.2 23.1115 8.26666 26.0448 8.26666 29.7782V57.7782C8.26666 61.5115 11.2 64.4448 14.9333 64.4448H65.0667C68.8 64.4448 71.7333 61.5115 71.7333 57.7782V29.7782C71.7333 26.0448 68.8 23.1115 65.0667 23.1115ZM40 57.2448C32.2667 57.2448 26.1333 51.1115 26.1333 43.3782C26.1333 35.6448 32.2667 29.5115 40 29.5115C47.7333 29.5115 53.8667 35.6448 53.8667 43.3782C53.8667 50.8448 47.7333 57.2448 40 57.2448ZM60.5333 34.8448C59.4667 34.8448 58.4 34.0448 58.4 32.7115C58.4 31.3782 59.2 30.5782 60.5333 30.5782C61.6 30.5782 62.6667 31.3782 62.6667 32.7115C62.6667 34.0448 61.6 34.8448 60.5333 34.8448Z" fill="#365496"/>
                            </svg>
                            <p className={"text-primary text-sm"}>{langManager.takePhoto}</p>
                        </button>
                    </>}
            </div>
        </div>
    )

    const $getCheckedButton = (checked: boolean) => {
        return checked ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.3403 2H7.6703C4.2803 2 2.0003 4.38 2.0003 7.92V16.09C2.0003 19.62 4.2803 22 7.6703 22H16.3403C19.7303 22 22.0003 19.62 22.0003 16.09V7.92C22.0003 4.38 19.7303 2 16.3403 2" stroke="#365496" strokeWidth="1.5"/>
            <path d="M10.8134 15.248C10.5894 15.248 10.3654 15.163 10.1944 14.992L7.8214 12.619C7.4794 12.277 7.4794 11.723 7.8214 11.382C8.1634 11.04 8.7164 11.039 9.0584 11.381L10.8134 13.136L14.9414 9.00796C15.2834 8.66596 15.8364 8.66596 16.1784 9.00796C16.5204 9.34996 16.5204 9.90396 16.1784 10.246L11.4324 14.992C11.2614 15.163 11.0374 15.248 10.8134 15.248Z" fill="#365496"/>
        </svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.3403 1.9998H7.6703C4.2803 1.9998 2.0003 4.3798 2.0003 7.9198V16.0898C2.0003 19.6198 4.2803 21.9998 7.6703 21.9998H16.3403C19.7303 21.9998 22.0003 19.6198 22.0003 16.0898V7.9198C22.0003 4.3798 19.7303 1.9998 16.3403 1.9998" stroke="#8698C0" strokeWidth="1.5"/>
        </svg>
    }

    const errMsForInsurance = submitted && (!skipInsurance && (!patientInfo.insuranceCardBackBase64 || !patientInfo.insuranceCardFrontBase64)) ? "Insurance card are required if you do not skip them." : ""
    const $insurance = (
        <Element name={ElementID.insurance}>
            <div className={"w-full flex flex-col space-y-4"}>
                <p className={"text-sm font-medium text-black leading-5"}>{langManager.insurance}</p>
                <div className={"w-full"}>
                    <button type={"button"} onClick={() => {
                        setSkipInsurance(!skipInsurance)
                    }} className={"w-full flex flex-row items-center space-x-2"}>
                        {$getCheckedButton(skipInsurance)}
                        <p className={"text-sm text-black leading-5"}>{langManager.skipInsurance}</p>
                    </button>
                    {errMsForInsurance && errMsForInsurance.length ? <p className={"text-sm italic text-error"}>{errMsForInsurance}</p> : null}
                </div>
                {$insuranceCards}
            </div>
        </Element>
    )

    const $profileListForNewPatient = (
        <div className={"w-full flex flex-col space-y-2 mt-4"}>
            {$name}
            {$dob}
            {$martialStatus}
            {$gender}
            {$race}
            {$ethnicity}
            {$phoneNumber}
            {$email}
            {$language}
            {$Notification}
            {$addressLine1}
            {$addressLine2}
            {$city}
            {$state}
            {$zip}
            {$insurance}
        </div>
    )

    const $fixedLine = (
        <div className={"p-1 pb-2 border-b"}>
            <p className={"text-xs leading-4 text-[#828282] italic"}>{langManager.contactClinicInfo}</p>
        </div>
    )
    const $profileListForNewPatientForExistingPatient = (
        <div className={"w-full flex flex-col space-y-2 mt-4"}>
            {$name}
            {$dob}
            {$fixedLine}
            {$ethnicity}
            {$race}
            {$martialStatus}
            {$gender}
            {$phoneNumber}
            {$email}
            {$language}
            {$Notification}
            {$addressLine1}
            {$addressLine2}
            {$city}
            {$state}
            {$zip}
            {$insurance}
        </div>
    )

    const scrollToElement = (id: ElementID) => {
        scroller.scrollTo(id, {
            duration: 500,
            smooth: true,
            offset: -72,
        })
    }

    const checkInputParam = () => {
        if (patientInfo.patientID === 0) {
            if (!patientInfo.patientMobilePhone.length) {
                return ElementID.phoneNumber
            }
        }
        if (!patientInfo.patientFirstName.length ||
            !patientInfo.patientLastName) {
            return ElementID.name
        }
        if (!patientInfo.patientDOB.length) {
            return ElementID.dob
        }
        if (!patientInfo.patientMarrage.name.length) {
            return ElementID.marriageStatus
        }
        if (!patientInfo.patientGender.name.length) {
            return ElementID.gender
        }
        if (!patientInfo.race.name.length) {
            return ElementID.race
        }
        if (!patientInfo.ethnicity.name.length) {
            return ElementID.ethnicity
        }
        if (!validateEmail(patientInfo.patientEMail)) {
            return ElementID.email
        }
        if (!patientInfo.language.name.length) {
            return ElementID.language
        }
        if (!patientInfo.contactMethod.name.length) {
            return ElementID.notification
        }
        if (!patientInfo.patientAddrStreet.length ||
            !patientInfo.patientAddrCity.length ||
            !patientInfo.patientAddrState.name.length ||
            !patientInfo.patientAddrZip.length
        ) {
            return ElementID.address
        }
        if (!skipInsurance && (!patientInfo.insuranceCardBackBase64 || !patientInfo.insuranceCardFrontBase64)) {
            return ElementID.insurance
        }

        return undefined
    }

    const onCheckIn = (complete: (successful: boolean) => void) => {
        token && checkin(token, complete)
    }

    const onNavigateToNext = () => {
        setSubmitted(true)
        const eID = checkInputParam()
        if (eID) {
            scrollToElement(eID)
            return
        }

        // Existing patient
        if (patientInfo.patientID > 0) {
            showSpinner("updatePatientInfo")
            updatePatientInfo(patientInfo, skipInsurance, (isSuccess) => {
                hideSpinner("updatePatientInfo")
                if (isSuccess) {
                    onCheckIn((successful) => {
                        if (successful) {
                            if (openInApp) {
                                BridgeHelper.popPage()
                            } else {
                                dispatchActionState({type: ActionType.page, value: Page.checkIn})
                            }
                        } else {
                            alert("Check-in failed")
                        }
                    })
                } else {
                    alert("Update failed.")
                }
            })
        } else {
            // New patient
            mPrint("patient info", patientInfo)
            showSpinner("updatePatientInfo")
            updatePatientInfo(patientInfo, skipInsurance, (isSuccess) => {
                hideSpinner("updatePatientInfo")
                if (isSuccess) {
                    if (skipInsurance) {
                        mPrint("skip insurance info for new patient")
                        props.onSavePatientInfo({...patientInfo, insuranceCardFrontBase64: null, insuranceCardBackBase64: null})
                    } else {
                        props.onSavePatientInfo(patientInfo)
                    }
                    dispatchActionState({type: ActionType.page, value: Page.consentForm})
                } else {
                    alert("Update failed.")
                }
            })
        }
    }

    const $buttons = (
        <div className={"w-full grid grid-cols-2 space-x-5 mt-6"}>
            <button onClick={() => {
                dispatchActionState({type: ActionType.page, value: actionState.lastPage})
            }} type={"button"} className={" py-3 px-2 text-primary font-medium bg-white border-2 border-primary rounded-xl"}>
                {langManager.back}
            </button>

            <button type={"button"} onClick={onNavigateToNext} className={"py-3 px-2 text-white font-medium bg-primary rounded-xl"}>
                {patientInfo.patientID > 0 ? langManager.checkIn : langManager.continue}
            </button>
        </div>
    )

    const $profileList = patientInfo.patientID ? $profileListForNewPatientForExistingPatient : $profileListForNewPatient

    return (
        <div className={"w-full"}>
            <div className={"w-full bg-white px-5 pt-4 pb-10"}>
                {$title}
                {$description}
                {$profileList}
                {$buttons}
            </div>
            {$cameraPicker}
        </div>
    )
}
